<template>
  <Form :label-width="140">
    <div class="spin" v-if="loading">
      <Spin fix />
    </div>
    <FormItem
      v-for="f in list"
      :key="f.key"
      :label="`${f.key}：`"
      class="formItem"
    >{{ f.val }}</FormItem>
  </Form>
</template>

<script>
import { GetEngInfo } from '@api'
import { initEngField, formatDate } from '@libs/util'
export default {
  name: 'information-details',
  data () {
    return {
      list: [],
      loading: false
    }
  },
  mounted () {
    this.getInfo()
  },
  methods: {
    async getInfo () {
      this.loading = true
      try {
        const query = { ENG_SID: this.$route.query.id }
        let { data } = await GetEngInfo(query)
        data.END_DATE = formatDate(data.END_DATE)
        data.START_DATE = formatDate(data.START_DATE)
        this.list = initEngField(data)
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.formItem {
  margin-bottom: 0px;
}
.spin {
  height: 500px;
}
</style>